import { render } from "./SupportApp.vue?vue&type=template&id=8f1ba744&scoped=true"
import script from "./SupportApp.vue?vue&type=script&lang=js"
export * from "./SupportApp.vue?vue&type=script&lang=js"

import "./SupportApp.vue?vue&type=style&index=0&id=8f1ba744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1ba744"]])

export default __exports__